export class ShareBudget {
    booker: Booker;
    coBooker: Booker;
    applyCoBudget: boolean;
    totalBudget: number;

    constructor(booker?: Booker, coBooker?: Booker) {
        this.booker = booker;
        this.coBooker = coBooker;
    }
}

export class Booker {
    userId: number;
    companyId: number;
    email: string;
    amount: number;
    fullName: string;
    shareBudgetCode: string;

    constructor(userId: number, companyId: number, email: string, amount: number, fullName?: string, shareBudgetCode?: string) {
        this.userId = userId;
        this.companyId = companyId;
        this.email = email;
        this.amount = amount;
        this.fullName = fullName;
        this.shareBudgetCode = shareBudgetCode;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-share-budget/dialog-share-budget.model.ts